import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.forgotPassword || initialState;

export const selectForgotPassword = createSelector(
  [selectSlice],
  state => state,
);
export const selectForgotError = createSelector(
  [selectSlice],
  state => state.error,
);
export const selectSeverity = createSelector(
  [selectSlice],
  state => state.severity,
);
